import {ReactElement} from 'react'
import {useQueryApiV2} from '../../../shared/hooks/use-query-api-v2'
import {BannersCarousel} from '../components/BannersCarousel'
import {PromotionBanner} from './PromotionBanner'
import {CurrentPromotion} from './types'
import {Client} from '../../../graphql/types'

export function PromotionAwareBanners({isClientEligible, company}: {isClientEligible: boolean; company: Client['company']}): ReactElement | null {
  const [promotion, {loading, error}] = useQueryApiV2<CurrentPromotion | null>({path: '/dashboard/promotions/current'})
  if (!loading && !error && promotion?.campaign.rules.promotion.display.bannerEnabled) return <PromotionBanner />
  return <BannersCarousel isClientEligible={isClientEligible} company={company} />
}
